var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default-new',[_c('div',[_c('process-report',{attrs:{"reportHeaders":_vm.reportHeaders,"report-data":_vm.stateInvoiceJournal.documentDefinition}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }